export const SLOW_DRAMA_WORKFLOWS = {
  ai_manga: {
    workflowType: 'ai_manga',
    name: 'AI漫剧剧本创作',
    pageTitle: 'AI漫剧剧本创作',
    projectLabel: '漫剧',
    defaultProjectTitle: '未命名漫剧项目',
    listRouteName: 'SlowDrama',
    detailRouteName: 'SlowDramaDetail',
    listPath: '/slow-drama',
    detailPath: '/slow-drama/detail/:id?',
    synopsisAssistantTitle: '短剧全案策划大师',
    segmentAssistantTitle: '短剧段落规划大师',
    episodeOutlineTitle: '集纲扩写智能体',
    dialogueAssistantTitle: '对话稿智能体'
  },
  sweet_romance: {
    workflowType: 'sweet_romance',
    name: '女频细糠剧本创作',
    pageTitle: '女频细糠剧本创作',
    projectLabel: '女频细糠',
    defaultProjectTitle: '未命名女频细糠项目',
    listRouteName: 'SweetDrama',
    detailRouteName: 'SweetDramaDetail',
    listPath: '/sweet-drama',
    detailPath: '/sweet-drama/detail/:id?',
    synopsisAssistantTitle: '女频细糠短剧规划书智能体',
    segmentAssistantTitle: '女频细糠段落规划智能体',
    episodeOutlineTitle: '女频细糠集纲扩写智能体',
    dialogueAssistantTitle: '女频细糠对话稿智能体'
  },
  sweet_romance_2: {
    workflowType: 'sweet_romance_2',
    name: '女频细糠剧本创作2',
    pageTitle: '女频细糠剧本创作2',
    projectLabel: '女频细糠',
    defaultProjectTitle: '未命名女频细糠项目2',
    listRouteName: 'SweetDrama2',
    detailRouteName: 'SweetDramaDetail2',
    listPath: '/sweet-drama-2',
    detailPath: '/sweet-drama-2/detail/:id?',
    synopsisAssistantTitle: '女频细糠短剧规划书智能体2',
    segmentAssistantTitle: '女频细糠段落规划智能体2',
    episodeOutlineTitle: '女频细糠集纲扩写智能体2',
    dialogueAssistantTitle: '女频细糠对话稿智能体2'
  },
  sweet_romance_3: {
    workflowType: 'sweet_romance_3',
    name: '女频细糠剧本创作3',
    pageTitle: '女频细糠剧本创作3',
    projectLabel: '女频细糠',
    defaultProjectTitle: '未命名女频细糠项目3',
    listRouteName: 'SweetDrama3',
    detailRouteName: 'SweetDramaDetail3',
    listPath: '/sweet-drama-3',
    detailPath: '/sweet-drama-3/detail/:id?',
    synopsisAssistantTitle: '女频细糠短剧规划书智能体3',
    segmentAssistantTitle: '女频细糠段落规划智能体3',
    episodeOutlineTitle: '女频细糠集纲扩写智能体3',
    dialogueAssistantTitle: '女频细糠对话稿智能体3'
  }
}

export const SLOW_DRAMA_WORKFLOW_LIST = Object.values(SLOW_DRAMA_WORKFLOWS)

export const DEFAULT_SLOW_DRAMA_WORKFLOW_TYPE = 'ai_manga'

export const getSlowDramaWorkflowConfig = (workflowType) => {
  const key = String(workflowType || '').trim()
  return SLOW_DRAMA_WORKFLOWS[key] || SLOW_DRAMA_WORKFLOWS[DEFAULT_SLOW_DRAMA_WORKFLOW_TYPE]
}

export const getSlowDramaWorkflowTypeFromRoute = (route) => (
  route?.meta?.workflow_type || DEFAULT_SLOW_DRAMA_WORKFLOW_TYPE
)

export const buildSlowDramaRoutes = (listComponent, detailComponent) => (
  SLOW_DRAMA_WORKFLOW_LIST.flatMap((config) => ([
    {
      path: config.listPath,
      name: config.listRouteName,
      component: listComponent,
      meta: {
        requiresAuth: true,
        showSidebar: true,
        workflow_type: config.workflowType,
        page_title: config.pageTitle
      }
    },
    {
      path: config.detailPath,
      name: config.detailRouteName,
      component: detailComponent,
      meta: {
        requiresAuth: true,
        workflow_type: config.workflowType,
        page_title: config.pageTitle
      }
    }
  ]))
)

export const APP_SIDEBAR_ITEMS = [
  { routeName: 'Home', path: '/', title: '短剧剧本创作' },
  ...SLOW_DRAMA_WORKFLOW_LIST.map((config) => ({
    routeName: config.listRouteName,
    path: config.listPath,
    title: config.pageTitle
  }))
]

export const getAppPageTitle = (route) => {
  const routeName = String(route?.name || '')
  if (route?.meta?.page_title) {
    return String(route.meta.page_title)
  }
  const titleMap = {
    Home: '短剧剧本创作',
    Shakespeare: '莎士比耶写作助手'
  }
  return titleMap[routeName] || '短剧剧本创作'
}
